export const region = 'ap-northeast-1';
export const stage: 'develop' | 'staging' | 'production' = 'develop';
export const bkpPath = 'https://edge.bitkey.tokyo/v1';
export const ifBaseApiPath = 'https://develop.api.og.bitlock.xyz/link/api/v1';
export const bitlockApiPath =
  'https://us-central1-bitlock-staging.cloudfunctions.net/ext-v1';
export const bitlockVoApiPath =
  'https://us-central1-bitlock-staging.cloudfunctions.net/ext-vo';
export const bitlockVoApiKey = `xkoejfkwjkdhsfjkh7348979285-2nklnfklnfklfl.ekkjnfgknjkn.mvffl`;
export const bitlockVoVerifyIdentityApiKey = `dhfhsdhfuodsghfhflh782942oyvuhnvakkqkdkhvbfrwrywv4756295viu24y587`;

// Datadog RUM（applicationId・clientToken を発行後に datadogEnabled を true に変更すること）
export const datadogEnabled = false;
export const datadogApplicationId = '';
export const datadogClientToken = '';
export const datadogService = 'bitlock-og-entry-service';
export const datadogSite = 'datadoghq.com';

// v2用のAPIパス
export const v2BaseApiPath = 'https://develop.api.og.bitlock.xyz/link/api/v1/sumamoru-v2';
export const homehubApiPath = 'https://api.develop-homehub.site/sumamoruApi/v1';
